import PropTypes from "prop-types";
/**
 * Created by fers on 25.07.16.
 */

import Relay from 'react-relay';

interface UpdateErrorsUserMutationProps {
  id?: any;
  notifyErrors?: any;
  notifyErrorsFreq?: any;
}

export default class UpdateErrorsUserMutation extends Relay.Mutation<UpdateErrorsUserMutationProps> {
  static propTypes = {
    id: PropTypes.any,
    notifyErrors: PropTypes.any,
    notifyErrorsFreq: PropTypes.any
  };
  getMutation() {
    return Relay.QL`mutation {updateUser}`;
  }
  getVariables() {
    return {
      id: this.props.id,
      notifyErrors: this.props.notifyErrors,
      notifyErrorsFreq: this.props.notifyErrorsFreq
    };
  }
  // Use this method to design a ‘fat query’ – one that represents every
  // field in your data model that could change as a result of this mutation.
  // Liking a story could affect the likers count, the sentence that
  // summarizes who has liked a story, and the fact that the viewer likes the
  // story or not. Relay will intersect this query with a ‘tracked query’
  // that represents the data that your application actually uses, and
  // instruct the server to include only those fields in its response.
  getFatQuery() {
    return Relay.QL`
            fragment on UpdateUserPayload {
                updatedNode {
                    id,
                    notifyErrors,
                    notifyErrorsFreq
                }
            }
        `;
  }
  // These configurations advise Relay on how to handle the LikeStoryPayload
  // returned by the server. Here, we tell Relay to use the payload to
  // change the fields of a record it already has in the store. The
  // key-value pairs of ‘fieldIDs’ associate field names in the payload
  // with the ID of the record that we want updated.
  getConfigs() {
    return [{
      type: 'REQUIRED_CHILDREN',
      children: [this.getFatQuery()]
    }];
  }
}